// YouTube Channel IDs for live video monitoring
// These are read from environment variables
export const YOUTUBE_CHANNELS = (() => {
  const channelIds = process.env.REACT_APP_YOUTUBE_CHANNEL_IDS;
  
  if (!channelIds) {
    console.warn('REACT_APP_YOUTUBE_CHANNEL_IDS not found in environment variables');
    return [];
  }
  
  // Split by comma and trim whitespace
  return channelIds.split(',').map(id => id.trim()).filter(id => id);
})();

// YouTube Data API v3 configuration
export const YOUTUBE_API_CONFIG = {
  // You'll need to get this from Google Cloud Console
  API_KEY: process.env.REACT_APP_YOUTUBE_API_KEY || 'YOUR_YOUTUBE_API_KEY_HERE',
  BASE_URL: 'https://www.googleapis.com/youtube/v3',
  SEARCH_ENDPOINT: '/search',
  VIDEOS_ENDPOINT: '/videos',
  CHANNELS_ENDPOINT: '/channels'
};

// API endpoints
export const YOUTUBE_ENDPOINTS = {
  SEARCH_LIVE: `${YOUTUBE_API_CONFIG.BASE_URL}${YOUTUBE_API_CONFIG.SEARCH_ENDPOINT}`,
  VIDEO_DETAILS: `${YOUTUBE_API_CONFIG.BASE_URL}${YOUTUBE_API_CONFIG.VIDEOS_ENDPOINT}`,
  CHANNEL_DETAILS: `${YOUTUBE_API_CONFIG.BASE_URL}${YOUTUBE_API_CONFIG.CHANNELS_ENDPOINT}`
};
